import { SELECTED_TAB_QUERY_PARAM } from "single-spa/react-app/config/solutions25/industryResearchConfig";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { ECategoryLeadersMetricType } from "../category-leaders/CategoryLeaders.types";

import { TABS } from "./consts";

export const navigateToWebsiteRankingsTab = (tabId: ECategoryLeadersMetricType) => {
    const currentParams = proNavigator.getParams();
    const { category, country, duration, webSource } = currentParams;

    if (!category) {
        return;
    }

    if (tabId === ECategoryLeadersMetricType.CategoryLeadersAll) {
        proNavigator.go("digitalsuite_marketresearch_webmarketanalysis_mapping", {
            category,
            country,
            duration,
            webSource: webSource || "Total",
        });
    } else {
        proNavigator.go("digitalsuite_marketresearch_webmarketanalysis_rankings", {
            category,
            country,
            duration,
            webSource: webSource || "Total",
            [SELECTED_TAB_QUERY_PARAM]: ECategoryLeadersMetricType[tabId],
        });
    }
};

export const isTabLocked = (tabId: ECategoryLeadersMetricType) => {
    const tab = TABS.find((tab) => tab.id === tabId);
    return tab?.isLocked ?? false;
};
